/** Client-visible message on payment request (aligned with common API limits). */
export const PAYMENT_REQUEST_MESSAGE_MAX_LENGTH = 255;

export const PAYMENT_PLAN_TOTAL_MISMATCH_MESSAGE = 'Payment plan total is not equal to the Payment Request total';

export const PAYMENT_PLAN_INVOICE_TOTAL_MISMATCH_MESSAGE = 'Payment plan total is not equal to the invoice total.';

/** Shown under each installment amount field when value is missing, zero, or negative. */
export const PAYMENT_PLAN_INSTALLMENT_AMOUNT_INVALID = 'Enter an amount greater than zero';

/** Inline helper when payment request case payment structure is Flat Fee. */
export const FLAT_FEE_TRUST_ONLY_HELPER_TEXT = 'Flat fee cases require deposits into a trust account.';

/** Validation error when a flat-fee payment request selects a non-trust deposit account. */
export const FLAT_FEE_OPERATING_DEPOSIT_ERROR = 'Flat fee payment requests must use a trust deposit account.';
